// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import KpiController from "./kpi_controller"
application.register("kpi", KpiController)

import LicenseplateLookupController from "./licenseplate_lookup_controller"
application.register("licenseplate-lookup", LicenseplateLookupController)

import AddressLookupController from "./address_lookup_controller"
application.register("address-lookup", AddressLookupController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import SchedulerInformationController from "./scheduler_information_controller"
application.register("scheduler-information", SchedulerInformationController)

import ServiceCodeController from "./service_code_controller"
application.register("service-code", ServiceCodeController)

import SettingsSidepanelController from "./settings_sidepanel_controller"
application.register("settings-sidepanel", SettingsSidepanelController)

import SettingsSubTaskTypesController from "./settings_sub_task_types_controller"
application.register("settings-sub-task-types", SettingsSubTaskTypesController)

import SettingsTaskTypesController from "./settings_task_types_controller"
application.register("settings-task-types", SettingsTaskTypesController)

import SettingsUsersController from "./settings_users_controller"
application.register("settings-users", SettingsUsersController)

import TasksController from "./tasks_controller"
application.register("tasks", TasksController)


/************************************
 * CLIENT PORTAL CONTROLLERS
 ************************************/

import ClientPortalTasksController from "./client_portal_tasks_controller"
application.register("client-portal-tasks", ClientPortalTasksController)

import ClientPortalTasksTableController from "./client_portal_tasks_table_controller"
application.register("client-portal-tasks-table", ClientPortalTasksTableController)
